export default __webpack_public_path__ + "d44dac80ed381f42f0002bae0a56a590.png";